<template>
  <span class="svg-ico-minus-circle">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5977 22.8281C7.0531 22.8281 2.59766 18.3727 2.59766 12.8281C2.59766 7.28358 7.0531 2.82812 12.5977 2.82812C18.1422 2.82812 22.5977 7.28358 22.5977 12.8281C22.5977 18.3727 18.1422 22.8281 12.5977 22.8281ZM12.5977 4.31327C7.94419 4.31327 4.0828 8.17467 4.0828 12.8281C4.0828 17.4816 7.94419 21.343 12.5977 21.343C17.2511 21.343 21.1125 17.4816 21.1125 12.8281C21.1125 8.17467 17.2511 4.31327 12.5977 4.31327Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.34766 12.8279C8.34766 12.4137 8.68344 12.0779 9.09766 12.0779H16.0977C16.5119 12.0779 16.8477 12.4137 16.8477 12.8279C16.8477 13.2421 16.5119 13.5779 16.0977 13.5779H9.09766C8.68344 13.5779 8.34766 13.2421 8.34766 12.8279Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
